<template>
  <div class="order-conform">
    <section class="dialog-header">
      <h1>Uw opdracht is verzonden</h1>
    </section>
    <section class="dialog-content">
      <p>
        U wordt binnen {{ redirectDelay }} seconden teruggeleid naar uw
        bestelomgeving waar u uw opdracht verder kunt afronden. Wanneer u niet
        automatisch wordt teruggeleid, klik dan op de knop hieronder.
      </p>

      <div class="button-holder">
        <button class="pill-button" @click="redirect">Doorgaan</button>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    callback: Function,
    redirectDelay: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      redirectTimer: undefined
    }
  },
  created() {
    this.$router.push({ name: 'home' })
    this.rootStore.setHome()

    this.redirectTimer = setTimeout(() => {
      this.redirect()
    }, this.redirectDelay * 1000)
  },
  beforeUnmount() {
    clearTimeout(this.redirectTimer)
  },
  methods: {
    redirect() {
      clearTimeout(this.redirectTimer)

      if (this.callback) {
        this.callback()
      }

      this.$emit('close')
      window.location = this.url
    }
  }
}
</script>

<style lang="scss" scoped></style>
